import * as Topics from "Data/Topics";

// tslint:disable:member-ordering
export default class Settings {
    protected static _useDwellActivation: boolean = false;
    public static get useDwellActivation () { return Settings._useDwellActivation; }
    public static set useDwellActivation(pValue: boolean) {
        Settings._useDwellActivation = pValue;
        Settings.onSettingsChanged();
    }

    protected static _audioDescriptionEnabled: boolean = false;
    public static get audioDescriptionEnabled () { return Settings._audioDescriptionEnabled; }
    public static set audioDescriptionEnabled(pValue: boolean) {
        Settings._audioDescriptionEnabled = pValue;
        if (pValue === true && Settings._difficulty === 0) {
            Settings._obstacleSpeed = Math.min(Settings._obstacleSpeed, 1 / 7);
        }
        Settings.onSettingsChanged();
    }

    protected static _closedCaptionsEnabled: boolean = true;
    public static get closedCaptionsEnabled() { return Settings._closedCaptionsEnabled; }
    public static set closedCaptionsEnabled(pValue: boolean) {
        Settings._closedCaptionsEnabled = pValue;
        Settings.onSettingsChanged();
    }

    protected static _masterVolume: number = 1;
    public static get masterVolume() { return Settings._masterVolume; }
    public static set masterVolume(pValue: number) {
        Settings._masterVolume = pValue;
        Settings.onSettingsChanged();
    }

    protected static _soundEffectsVolume: number = 1;
    public static get soundEffectsVolume() { return Settings._soundEffectsVolume; }
    public static set soundEffectsVolume(pValue: number) {
        Settings._soundEffectsVolume = pValue;
        Settings.onSettingsChanged();
    }

    protected static _musicVolume: number = 1;
    public static get musicVolume() { return Settings._musicVolume; }
    public static set musicVolume(pValue: number) {
        Settings._musicVolume = pValue;
        Settings.onSettingsChanged();
    }

    protected static _voiceoverVolume: number = 0;
    public static get voiceoverVolume() { return Settings._voiceoverVolume; }
    public static set voiceoverVolume(pValue: number) {
        Settings._voiceoverVolume = pValue;
        Settings.onSettingsChanged();
    }

    protected static _buttonSizeMultiplier: number = 1;
    public static get buttonSizeMultiplier() { return Settings._buttonSizeMultiplier; }
    public static set buttonSizeMultiplier(pValue: number) {
        Settings._buttonSizeMultiplier = pValue;
        Settings.onSettingsChanged();
    }

    protected static _textSizeMultiplier: number = 1.375;
    public static get textSizeMultiplier() { return Settings._textSizeMultiplier; }
    public static set textSizeMultiplier(pValue: number) {
        Settings._textSizeMultiplier = pValue;
        Settings.onSettingsChanged();
    }

    protected static _hideBackgroundImages: boolean = false;
    public static get hideBackgroundImages() { return Settings._hideBackgroundImages; }
    public static set hideBackgroundImages(pValue: boolean) {
        Settings._hideBackgroundImages = pValue;
        Settings.onSettingsChanged();
    }

    protected static _buttonPosition: number = 0;
    public static get buttonPosition() { return Settings._buttonPosition; }
    public static set buttonPosition(pValue: number) {
        Settings._buttonPosition = pValue;
        Settings.onSettingsChanged();
    }

    protected static _difficulty: number = 0 / 3;
    public static get difficulty() { return Settings._difficulty; }
    public static set difficulty(pValue: number) {
        Settings._difficulty = pValue;
        if (pValue === 0 && Settings._audioDescriptionEnabled === true) {
            Settings._obstacleSpeed = Math.min(Settings._obstacleSpeed, 1 / 7);
        }
        Settings.onSettingsChanged();
    }

    protected static _obstacleSpeed: number = 3 / 7;
    public static get obstacleSpeed() { return Settings._obstacleSpeed; }
    public static set obstacleSpeed(pValue: number) {
        Settings._obstacleSpeed = pValue;
        Settings.onSettingsChanged();
    }

    protected static _moreAnimation: boolean = true;
    public static get moreAnimation() { return Settings._moreAnimation; }
    public static set moreAnimation(pValue: boolean) {
        Settings._moreAnimation = pValue;
        Settings.onSettingsChanged();
    }

    protected static _contrast: number = 0;
    public static get contrast() { return Settings._contrast; }
    public static set contrast(pValue: number) {
        Settings._contrast = pValue;
        Settings.onSettingsChanged();
    }

    protected static _colorBlindMode: number = 0;
    public static get colorBlindMode() { return Settings._colorBlindMode; }
    public static set colorBlindMode(pValue: number) {
        Settings._colorBlindMode = pValue;
        Settings.onSettingsChanged();
    }

    protected static onSettingsChanged() {
        PubSub.publishSync(Topics.SETTINGS_CHANGED, this as Readonly<typeof Settings>);
    }
}